export default "__VITE_ASSET__Bv_frmWZ__"